import * as React from 'react'
import * as R from 'ramda'
import injectSheet from 'react-jss'
import {singleColors} from '../Style'
import Button from 'material-ui-next/Button'

const styles = {
    root: {
        flex: '1'
    },
    button: {
        padding: '4px 8px',
        height: 'auto',
        lineHeight: 'auto',
        minWidth: '0',
        color: singleColors.labelColor
    },
    span: {
        padding: '3px 8px',
        float: 'left',
        marginTop: '10px'
    },
    divider: {
        width: '1px',
        borderRight: 'solid 1px',
        borderRightColor: singleColors.labelColor,
        margin: '0 8px'
    }
}

interface Properties {
    readonly itemsPerPage: number
    readonly onChange: (value: number) => void
}

export const PageSize =
    injectSheet<Properties>(styles)(
        ({classes, itemsPerPage, onChange}) => (
            <div className={classes.root}>
                <span className={classes.span}>Anzeigen:</span>
                {R.map(
                        count =>
                            [
                                <Button
                                    type="flat"
                                    className={classes.button}
                                    key={count}
                                    onClick={() => onChange(count)}
                                >
                                    <span
                                        style={{
                                            fontWeight:
                                                count === itemsPerPage
                                                    ? 'bold'
                                                    : 'normal',
                                        }}
                                    >
                                        {count}
                                    </span>
                                </Button>,
                                <span key={Math.random()} className={classes.divider}/>
                            ],
                        [10, 25, 50, 100])}
            </div>
        )
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/PageSize.tsx